




import { defineComponent } from '@vue/composition-api';

const name = 'ttam-placement-type-label-hint';

export default defineComponent({
  name,
  setup() {
    return {
      name,
    };
  },
});
